export const isNotNull = <T>(it: T): it is NonNullable<T> => it != null;
